<template>
  <div class="form-group row">
    <div class="col-sm-12">
      <font size="1">
        <p size="1" v-if="errosValidacaoDesanexar.length" class="erro">
          <b size="1">Favor, verificar o(s) campo(s) abaixo:</b>
          <ul size="1">
            <li v-for="erro in errosValidacaoDesanexar" v-bind:key="erro" size="1">
              {{ erro }}
            </li>
          </ul>
        </p>
      </font>
    </div>
    <alert-comp :msg="msgAlert" />

    <div class="col-sm-2 text-sm-right">
      <label>Motivo da Desanexação:</label>
    </div>
    <div class="col-sm-10 mb-3">
      <textarea class="form-control" v-model="param.motivacao" rows="5"></textarea>
      <label class="erro">{{erroValidacaoDesanexarMotivo}}</label>
    </div>

    <div class="row btnAcoes">
      <button class="btn btn-outline-danger" @click.prevent="desanexar"> Desanexar </button>
    </div>
  </div>
</template>

<script>
import eventBus from '@/uteis/eventBus'
import alertComp from '@/components/alert/AlertComp'

import VirtusService from '@/services/VirtusService'

export default {
  name: 'desanexar',

  components: {
    alertComp
  },

  props: {
    eventBusRecarregar: { required: true, type: String },
    processoDesanexado: { required: true, type: Object }
  },

  data () {
    return {
      msgAlert: {
        texto: '',
        type: ''
      },
      param: {
        motivacao: ''
      },
      errosValidacaoDesanexar: [],
      erroValidacaoDesanexarMotivo: '',
      erroDenaxamentoNaoPermitido: ''
    }
  },

  created () {
    this.service = new VirtusService()
  },

  methods: {
    desanexar () {
      if (this.validaDesanexacao()) {
        this.processoDesanexado.motivacao = this.param.motivacao
        this.service.desanexacao(this.processoDesanexado).then((resp) => {
          eventBus.$emit(this.eventBusRecarregar, resp)
        }).catch((err) => {
          if (err.response.status === 422) {
            this.msgAlert.texto = 'Essse Processo não pode ser Desanexado Ele foi tramitado com esse Anexo.'
            this.msgAlert.type = 'danger'
          }
        })
      }
    },
    validaDesanexacao () {
      this.errosValidacaoDesanexar = []
      this.erroValidacaoDesanexarMotivo = ''

      if (!this.param.motivacao) {
        this.erroValidacaoDesanexarMotivo = '*Motivo desanexação obrigatório'
        this.errosValidacaoDesanexar.push('Campo Motivo Desanexação.')
      }

      if (!this.errosValidacaoDesanexar.length) {
        return true
      }
    },
    validaDesanexacaoInválida () {

    }
  }
}
</script>

<style scoped lang="scss">
.row {
  margin-top: 2px;
}
.erro {
  color: orange;
}
</style>
